import { create } from "zustand";

const useMenuStore = create((set) => ({
  toggleMenu: false,
  setToggleMenu: () => set((state) => ({ toggleMenu: !state.toggleMenu })),
}));

const useThemeStore = create((set) => ({
  theme: {
    palette: {
      common: {
        white: "#ffffff",
        black: "#000000",
        background: "#ecf5fd",
      },
      miscellaneous: {
        grey: { main: "#454556", light: "#dadadd" },
      },
      primary: {
        // Main
        main: "#ffffff",
        contrastMain: "#000000",
        // Light
        light: "#ebf6fd",
        contrastLight: "#0A89E4",
      },
      secondary: {
        // Main
        main: "#454556",
        contrastMain: "#ffffff",
        // Light
        light: "#DADADA",
        contrastLight: "#242424",
      },
      success: {
        // Main
        main: "#227754",
        contrastMain: "#ffffff",
        // Light
        light: "#D6F9E8",
        contrastLight: "#227754",
      },
      warning: {
        // Main
        main: "#CC8900",
        contrastMain: "#ffffff",
        // Light
        light: "#FFF7E6",
        contrastLight: "#CC8900",
      },
      error: {
        // Main
        main: "#D60024",
        contrastMain: "#ffffff",
        // Light
        light: "#FFE7E7",
        contrastLight: "#D60024",
      },
    },
  },
}));

export { useMenuStore, useThemeStore };
